import React, { useState } from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  Image,
  Link,
  VStack,
  useBreakpointValue,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import PrimaryButton from '../../components/UI/PrimaryButton';
import InputWithIcon from '../../components/UI/InputWithIcon';
import { FaUser, FaLock } from 'react-icons/fa';

const logoUrl = 'https://s3-contel-imagens-aplicacao.s3.us-east-1.amazonaws.com/nogle/Brand.svg';
const logoSimboloUrl = 'https://s3-contel-imagens-aplicacao.s3.us-east-1.amazonaws.com/nogle/Simbolo+Verde+Neon.png';
const bannerUrl = 'https://s3-contel-imagens-aplicacao.s3.us-east-1.amazonaws.com/nogle/Banner+Desktop.svg';
const logoCinzaUrl = 'https://s3-contel-imagens-aplicacao.s3.us-east-1.amazonaws.com/nogle/Brand+cinza.svg';

const Login = () => {
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const isDesktop = useBreakpointValue({ base: false, lg: true });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await signIn({ email, password });
    if (response?.error) {
      setErrorMsg(response.error);
    } else {
      setErrorMsg('');
      navigate('/');
    }
  };

  if (isDesktop) {
    return (
      <Flex h="100vh" bg="background" overflow="hidden">
        <Flex
          w="35%"
          direction="column"
          py={{ base: 8, xl: 12 }}
          px={12}
          bg="surface"
        >
          <Box>
            <Image src={logoUrl} alt="Nogle Logo" w="8.5rem" />
          </Box>
          <Flex
            flex="1"
            align="center"
            justify="center"
          >
            <VStack as="form" onSubmit={handleSubmit} spacing={4} w="100%" maxW="380px" mx="auto">
              <Box w="full">
                <Text color="gray.300">Bem vindo!</Text>
                <Heading as="h3" size={{ base: 'md', lg: 'lg' }} color="white" mt={5} mb={2}>
                  Login <Text as="strong">Nogle<sup>&reg;</sup></Text>
                </Heading>
                <Text color="gray.300" mb={5}>
                  Acesse para descobrir todos os recursos.
                </Text>
              </Box>
              {errorMsg && <Text color="red.400">{errorMsg}</Text>}
              <InputWithIcon icon={FaUser} type="text" placeholder="E-mail/Nome de usuário" value={email} onChange={(e) => setEmail(e.target.value)} required />
              <InputWithIcon icon={FaLock} type="password" placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} required />
              <Link href="#" alignSelf="flex-end" fontSize="sm" color="gray.300" _hover={{ color: 'secondary' }}>
                Recuperar Senha
              </Link>
              <PrimaryButton type="submit">Entrar na Plataforma</PrimaryButton>
            </VStack>
          </Flex>
          <Flex align="center" justify="space-between" w="100%">
            <Text fontSize="10px" color="gray.500" flex="1" mr={4}>
              © {new Date().getFullYear()} Nogle Tech. Todos os direitos reservados. Toda a reprodução sem autorização,
              seja com fins comerciais ou não, é expressamente proibida.
            </Text>
            <Image src={logoCinzaUrl} alt="Nogle Logo Cinza" w="2.5rem"/>
          </Flex>
        </Flex>
        <Flex w="65%" align="center" justify="center" p={8}>
          <Box w="full" h="full" borderRadius="20px" boxShadow="0 4px 6px rgba(0,0,0,.1)" overflow="hidden">
            <Image src={bannerUrl} alt="Banner" w="100%" h="100%" objectFit="cover" />
          </Box>
        </Flex>
      </Flex>
    );
  }

  const logoBoxSize = "70px"; 

  return (
    <Flex direction="column" h="100dvh" bg="background" overflow="hidden" position="relative">
      <Box 
        h="35dvh" 
        flexShrink={0}
        px={4}
        pb={4}
      >
        <Box 
          w="100%" 
          h="100%" 
          borderRadius="2xl"
          overflow="hidden"
        >
          <Image 
            src={bannerUrl} 
            alt="Banner Mobile" 
            w="100%" 
            h="100%" 
            objectFit="cover" 
          />
        </Box>
      </Box>

      <Box
        position="absolute"
        top={`calc(35dvh - (${logoBoxSize} / 2))`}
        left="50%"
        transform="translateX(-50%)"
        bg="secondary"
        p={3}
        borderRadius="2xl"
        boxSize={logoBoxSize}
        zIndex={2}
        display="flex"
        alignItems="center"
        justifyContent="center"
        boxShadow="lg"
      >
        <Image 
          src={logoSimboloUrl} 
          alt="Símbolo Nogle" 
          filter="brightness(0) invert(1)"
          w="80%"
        />
      </Box>

      <Flex direction="column" align="center" flex="1" bg="surface" borderTopRadius="3xl" zIndex={1}>
        <VStack as="form" onSubmit={handleSubmit} spacing={3} w="100%" p={6} pt={`calc((${logoBoxSize} / 2) + 1.5rem)`}>
          <Heading as="h3" size="md" color="white" textAlign="center">
            Login <Text as="strong">Nogle<sup>&reg;</sup></Text>
          </Heading>
          <Text color="gray.300" fontSize="sm" textAlign="center" pb={2}>
            Acesse para descobrir todos os recursos.
          </Text>
          {errorMsg && <Text color="red.400" fontSize="sm">{errorMsg}</Text>}
          <InputWithIcon icon={FaUser} type="text" placeholder="E-mail/Nome de usuário" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <InputWithIcon icon={FaLock} type="password" placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <Link href="#" alignSelf="center" fontSize="sm" color="gray.300" _hover={{ color: 'secondary' }}>
            Recuperar Senha
          </Link>
          <PrimaryButton type="submit">Entrar na Plataforma</PrimaryButton>
        </VStack>
      </Flex>
    </Flex>
  );
};

export default Login;